import { StoreModel } from "../../models/Index";

export default function stopReceivingCash(Store: StoreModel, event: any) {
    return Store.shellClient.cashAcceptor.stopReceivingCash();
}
